/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConnectedDevicesResponse,
  LinkTokenExchangeResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * @summary Create Junction Link
 */
export const createJunctionLinkV0WearablesJunctionLinkPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LinkTokenExchangeResponse>(
      {url: `/v0/wearables/junction-link`, method: 'POST', signal
    },
      );
    }
  


export const getCreateJunctionLinkV0WearablesJunctionLinkPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>, TError,void, TContext> => {

const mutationKey = ['createJunctionLinkV0WearablesJunctionLinkPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>, void> = () => {
          

          return  createJunctionLinkV0WearablesJunctionLinkPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJunctionLinkV0WearablesJunctionLinkPostMutationResult = NonNullable<Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>>
    
    export type CreateJunctionLinkV0WearablesJunctionLinkPostMutationError = unknown

    /**
 * @summary Create Junction Link
 */
export const useCreateJunctionLinkV0WearablesJunctionLinkPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createJunctionLinkV0WearablesJunctionLinkPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateJunctionLinkV0WearablesJunctionLinkPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get Connected Junction Devices
 */
export const getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ConnectedDevicesResponse>(
      {url: `/v0/wearables/connected-junction-devices`, method: 'GET', signal
    },
      );
    }
  

export const getGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryKey = () => {
    return [`/v0/wearables/connected-junction-devices`] as const;
    }

    
export const getGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>> = ({ signal }) => getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>>
export type GetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryError = unknown


export function useGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet<TData = Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet<TData = Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet<TData = Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Connected Junction Devices
 */

export function useGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet<TData = Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConnectedJunctionDevicesV0WearablesConnectedJunctionDevicesGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



